import React from 'react';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import PricingFAQ from '../components/Service/Pricing/FAQ';
import PricingPlan from '../components/Service/Pricing/Plan';
import PricingTimeline from '../components/Service/Pricing/Timeline';
import Testimonials from '../components/organisms/Testimonials';
import { plans } from '../constants/planInfo';

const Pricing = () => {
  const { t } = useTranslation('common');

  const colors = ['green', 'purple', 'blue', 'orange'];
  const planList = plans.map((plan) => (
    <PricingPlan key={plan.name} color={colors.shift()} plan={plan} />
  ));
  return (
    <div className="pricing">
      <Head>
        <title>{t('title.pricing')}</title>
        <meta name="description" content={t('description.pricing')} />
      </Head>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 pt-24">
        <h1 className="mb-4 text-center text-2xl lg:text-4xl font-bold">
          {t('service.pricing.title')}
        </h1>
        <p className="intro col-span-12 md:col-span-8 col-center text-center">
          {t('service.pricing.intro')}
        </p>
        <div className="plan-wrapper grid grid-cols-12 gap-4 mt-16 mb-8">
          {planList}
        </div>
      </div>
      <PricingTimeline />
      <div className="pricing-testimonials">
        <Testimonials />
      </div>
      <PricingFAQ />
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default Pricing;
